import { Text, View } from "react-native";
import MaterialCommunityIcons from "react-native-vector-icons/MaterialCommunityIcons";
import styles from "./StatutDemande.styles";
import { getStatusColor, getStatusIcon, getStatusName } from "./StatutDemande.constants";

export default function PastilleStatutDemande({statut}: {statut: string}) {
    return (
        <View style={[styles.statusBadge, { backgroundColor: getStatusColor(statut) }]}>
            <MaterialCommunityIcons
                name={getStatusIcon(statut)}
                size={16}
                color="white"
            />
            <Text style={styles.statusText}>
                {getStatusName(statut)}
            </Text>
        </View>
    );
}
